import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14 13a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 11 10q0-1.25.875-2.125A2.9 2.9 0 0 1 14 7q1.25 0 2.125.875C17 8.75 17 9.167 17 10s-.292 1.542-.875 2.125A2.9 2.9 0 0 1 14 13m-7 3q-.824 0-1.412-.588A1.93 1.93 0 0 1 5 14V6q0-.824.588-1.412A1.93 1.93 0 0 1 7 4h14q.824 0 1.413.588Q23 5.175 23 6v8q0 .825-.587 1.412A1.93 1.93 0 0 1 21 16zm2-2h10q0-.825.587-1.412A1.93 1.93 0 0 1 21 12V8q-.824 0-1.413-.588A1.93 1.93 0 0 1 19 6H9q0 .824-.588 1.412A1.93 1.93 0 0 1 7 8v4q.824 0 1.412.588Q9 13.175 9 14m10 6H3q-.824 0-1.413-.587A1.93 1.93 0 0 1 1 18V8a.97.97 0 0 1 .288-.713A.97.97 0 0 1 2 7a.97.97 0 0 1 .712.287Q3 7.575 3 8v10h16q.424 0 .712.288.288.287.288.712c0 .425-.096.52-.288.712A.97.97 0 0 1 19 20" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }